<app-tab-list
    (onAdd)="emit_btnAddClick()"
    (onClick)="emit_onClick($event)"
    (onRestore)="emit_onRestore($event)"
    (onDeleteDeep)="emit_onDeleteDeep($event)"
    [(tabMode)]="tabMode$$"
    [btnAddData]="btnAddData$$()"
    [btnDeleteData]="btnDeleteData$$()"
    [claimPageList]="claimPageList$$()"
    [buttonsHide]="buttonsHide$$()"
    [itemLines]="itemLines"
    [itemSize]="ItemSize"
    [noClick]="noClick$$()"
    [template]="template"
/>

<ng-template #template let-listItem>
    @if (!ready$$()) {
        <div class="loading-overlay"><div class="spinner"></div></div>
    } @else {
    <div class="thumbnail-scroll">
    <div
        #grid
        class="thumbnail-grid"
        [class.selection-mode]="selectionMode$$()"
        [class.main-photo-drag]="_mainPhotoDragActive$$()"
        cdkDropList
        [id]="_tablistDropId"
        cdkDropListOrientation="mixed"
        [cdkDropListData]="displayedList$$()"
        [cdkDropListSortingDisabled]="_mainPhotoDragActive$$()"
        (cdkDropListDropped)="emit_onDrop($event)"
        (cdkDropListSorted)="emit_onSorted($event)"
    >
        @for (item of displayedList$$(); track item.guid) {
            <div
                class="thumbnail-item"
                [class.draggable]="canEdit$$() && !selectionMode$$() && !_filterActive$$()"
                [class.selected]="selectedGuids$$().has(item.guid)"
                cdkDrag
                [cdkDragData]="item"
                [cdkDragDisabled]="!canEdit$$() || selectionMode$$() || _filterActive$$()"
                [cdkDragStartDelay]="dragStartDelay"
                (cdkDragStarted)="emit_onDragStarted()"
                (cdkDragMoved)="emit_onDragMoved($event, item)"
                (cdkDragEnded)="emit_onDragEnded($event, item)"
                (pointerdown)="emit_pointerDown($event, item)"
                (pointermove)="emit_pointerMove($event)"
                (pointerup)="emit_pointerUp()"
                (pointercancel)="emit_pointerUp()"
                (click)="emit_onClick(item)"
            >
                <app-image-box-tab-list
                    [guid]="item.thumbGuid"
                    [version]="item.version"
                    [border]="true"
                    [noClick]="true"
                />

                <!-- Caption onderaan de thumbnail: aanmaakdatum + omschrijving op één regel,
                     gescheiden door ':' (lichtgrijs doorschijnend, omschrijving afgekapt met ellipsis).
                     pointer-events:none zodat klik/sleep op de tegel blijft werken. -->
                @if (item.dateShort || item.description) {
                    <div class="thumbnail-caption">
                        @if (item.dateShort) {
                            <span class="cap-date">{{ item.dateShort }}{{ item.description ? ':' : '' }}</span>
                        }
                        @if (item.description) {
                            <span class="cap-desc">{{ item.description }}</span>
                        }
                    </div>
                }

                <!-- Selectievakje rechtsboven, alleen in selectiemodus. -->
                @if (selectionMode$$()) {
                    <div
                        class="select-checkbox"
                        [class.checked]="selectedGuids$$().has(item.guid)"
                        (click)="emit_checkboxClick($event, item)"
                    >
                        @if (selectedGuids$$().has(item.guid)) {
                            <svg viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                            </svg>
                        }
                    </div>
                }

                <!-- Mainphoto-checkbox rechtsboven: toont welke foto de hoofdfoto is (imagebox) en
                     laat 'm aan/uitvinken (alternatief voor slepen). Standaard verborgen (verstoort
                     anders de lijst) — alleen zichtbaar na de footer-toggle (mainPhotoCheckboxesVisible$$,
                     die zelf al edit-recht vereist, zie template_buttons). -->
                @if (mainPhotoCheckboxesVisible$$()) {
                    <div
                        class="main-photo-checkbox"
                        [class.checked]="item.thumbGuid && item.thumbGuid === _tabListService.photoGuid$$()"
                        (click)="emit_mainPhotoCheckboxClick($event, item)"
                    >
                        @if (item.thumbGuid && item.thumbGuid === _tabListService.photoGuid$$()) {
                            <svg viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                            </svg>
                        }
                    </div>
                }

                <!-- Delen-checkbox rechtsboven (DomainUserPhotos, alleen beheerder): zelfde opmaak als
                     main-photo-checkbox, togglet FileBox.Shared direct. Nooit tegelijk met de
                     hoofdfoto-checkboxes hierboven of hieronder (zie emit_toggleShareCheckboxes). -->
                @if (shareCheckboxesVisible$$()) {
                    <div
                        class="main-photo-checkbox"
                        [class.checked]="item.shared"
                        (click)="emit_shareCheckboxClick($event, item)"
                    >
                        @if (item.shared) {
                            <svg viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                            </svg>
                        }
                    </div>
                }

                <!-- Eigen-hoofdfoto-checkbox rechtsboven (DomainUserPhotos, elke DomainUser): persoonlijke
                     keuze voor de herkenningsfoto van het Domain (DomainUser.DomainFileBoxId). -->
                @if (ownMainCheckboxesVisible$$()) {
                    <div
                        class="main-photo-checkbox"
                        [class.checked]="item.isMain"
                        (click)="emit_ownMainCheckboxClick($event, item)"
                    >
                        @if (item.isMain) {
                            <svg viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                            </svg>
                        }
                    </div>
                }

                <!-- Fallback-hoofdfoto-checkbox rechtsboven (Domain-pagina, wie Page_Update heeft op de
                     DomainPhotos-tab): domeinbrede fallback (Domain.PhotoFileBoxId). Checkbox-only, geen slepen. -->
                @if (fallbackCheckboxesVisible$$()) {
                    <div
                        class="main-photo-checkbox"
                        [class.checked]="item.isFallback"
                        (click)="emit_fallbackCheckboxClick($event, item)"
                    >
                        @if (item.isFallback) {
                            <svg viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                            </svg>
                        }
                    </div>
                }
            </div>
        } @empty {
            <div class="empty-grid">No images</div>
        }
    </div>
    </div>
    }

    <!-- Busy-overlay tijdens upload/delete: legt de grid op slot (blokkeert klikken) met een spinner.
        De voortgang zelf toont de footer-progressbar onderin het scherm. -->
    @if (busy$$()) {
        <div class="busy-overlay">
            <div class="spinner"></div>
        </div>
    }
</ng-template>

<!-- Footer-knoppen — getoond in de tab-footer via tabList_addContentButtons. De <ng-template>
     zelf blijft onconditioneel (anders bestaat de viewChild niet); de inhoud staat achter
     !loadingPage$$() (zie loadingPage$$ hierboven) zodat de knoppen alleen bij de initiële
     page-load synchroon met de content verschijnen, en niet bij elke latere tab-wissel
     verdwijnen/terugkomen. In selectiemodus: toggle / verwijderen (aantal) / annuleren; anders:
     mainphoto-toggle (bij edit-recht) / camera / galerij (bij claim btnListAdd_Show). -->
<ng-template #template_buttons>
    @if (!loadingPage$$()) {
        @if (selectionMode$$()) {
            <div class="button-row">
                <app-button-action (btnClick)="emit_cancelSelection()"
                    [disabled]="busy$$()"
                    [loadKey]="loadKey.pageLock"
                    [lockOnLoad]="true"
                    [tooltip]="'cancel'"
                >
                    <app-icon name="xmark" />
                </app-button-action>
                <app-button-action (btnClick)="emit_toggleSelectAll()"
                    [disabled]="busy$$()"
                    [loadKey]="loadKey.pageLock"
                    [lockOnLoad]="true"
                    [tooltip]="anySelected$$() ? 'deselect all' : 'select all'"
                >
                    {{ anySelected$$() ? 'none' : 'all' }}
                </app-button-action>
                <app-button-action (btnClick)="emit_deleteSelected()"
                    [disabled]="busy$$() || selectedCount$$() === 0"
                    [loadKey]="loadKey.pageLock"
                    [lockOnLoad]="true"
                    [tooltip]="'delete selection permanently'"
                >
                    delete @if (selectedCount$$() > 0) { ({{ selectedCount$$() }}) }
                </app-button-action>
            </div>
        } @else if (!cameraOpen$$() && (canEdit$$() || canAdd$$() || canMainPhoto$$() || canOwnMainPhoto$$() || canFallbackPhoto$$() || canShare$$())) {
            <div class="button-row">
                @if (canAdd$$()) {
                    <app-button-action (btnClick)="emit_cameraClick()"
                        [disabled]="busy$$() || uploadLimitReached$$()"
                        [loadKey]="loadKey.pageLock"
                        [lockOnLoad]="true"
                        [tooltip]="uploadCameraTooltip$$()">
                        <app-icon name="camera-plus"
                    />
                    </app-button-action>
                    <app-button-action (btnClick)="emit_galleryClick()"
                        [disabled]="busy$$() || uploadLimitReached$$()"
                        [loadKey]="loadKey.pageLock"
                        [lockOnLoad]="true"
                        [tooltip]="uploadGalleryTooltip$$()"
                    >
                        <app-icon name="images-plus" />
                    </app-button-action>
                }
                @if (canMainPhoto$$()) {
                    <app-button-action (btnClick)="emit_toggleMainPhotoCheckboxes()"
                        [disabled]="busy$$()"
                        [loadKey]="loadKey.pageLock"
                        [lockOnLoad]="true"
                        [tooltip]="mainPhotoCheckboxesVisible$$() ? 'hoofdfoto-selectie verbergen' : 'hoofdfoto kiezen'"
                    >
                        <app-icon name="image-favourite" />
                    </app-button-action>
                }
                @if (canOwnMainPhoto$$()) {
                    <app-button-action (btnClick)="emit_toggleOwnMainCheckboxes()"
                        [disabled]="busy$$()"
                        [loadKey]="loadKey.pageLock"
                        [lockOnLoad]="true"
                        [tooltip]="ownMainCheckboxesVisible$$() ? 'hoofdfoto-selectie verbergen' : 'hoofdfoto kiezen'"
                    >
                        <app-icon name="image-favourite" />
                    </app-button-action>
                }
                @if (canFallbackPhoto$$()) {
                    <app-button-action (btnClick)="emit_toggleFallbackCheckboxes()"
                        [disabled]="busy$$()"
                        [loadKey]="loadKey.pageLock"
                        [lockOnLoad]="true"
                        [tooltip]="fallbackCheckboxesVisible$$() ? 'fallback-selectie verbergen' : 'fallback-hoofdfoto kiezen'"
                    >
                        <app-icon name="domain-owner" />
                    </app-button-action>
                }
                @if (canShare$$()) {
                    <app-button-action (btnClick)="emit_toggleShareCheckboxes()"
                        [disabled]="busy$$()"
                        [loadKey]="loadKey.pageLock"
                        [lockOnLoad]="true"
                        [tooltip]="shareCheckboxesVisible$$() ? 'delen-selectie verbergen' : 'photos delen'"
                    >
                        <app-icon name="share" />
                    </app-button-action>
                }
            </div>
        }
    }
</ng-template>

<input #galleryInput type="file" [accept]="_acceptTypes$$()" multiple hidden (change)="emit_fileChange($event)" />

<!-- In-pagina camera (getUserMedia): vervangt de externe camera-app zodat Chrome niet de tab
     weggooit/herlaadt bij het maken van een foto. -->
@if (cameraOpen$$()) {
    <app-camera-capture (captured)="emit_cameraCaptured($event)" (closed)="emit_cameraClosed()" />
}
